import * as _ from 'underscore';
import { IDataSourceBase } from '../models/IDataSourceInfo';
import { Module } from '../Module';
import { DataSources } from '../resources/Datasources';
import {
  ISetDatasourceRemoteAgentReservationResult,
} from '../ServerApi/requests/SetDatasourceRemoteAgentReservationRequest';
import { IError } from '../ServerApi/types/IError';
import { IResult } from '../ServerApi/types/IResponse';
import { ChangeDatasourceRemoteAgentAction } from './ChangeDatasourceRemoteAgentAction';
import { ToasterService, ToastType } from './ToasterService';

export class ChangeDatasourceRemoteAgentReservationAction {

  public static $inject = ['$translate', 'ToasterService', 'DataSources', 'ChangeDatasourceRemoteAgentAction'];

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ToasterService: ToasterService,
    private DataSources: DataSources,
    private ChangeDatasourceRemoteAgentAction: ChangeDatasourceRemoteAgentAction) { }

  public execute(datasource: IDataSourceBase,
                 reservationId: string,
                 suppressSuccessToast: boolean): ng.IPromise<IResult> {

    return this.DataSources.setRemoteAgentReservation(datasource.id, reservationId).then((result: ISetDatasourceRemoteAgentReservationResult) => {
      if (!suppressSuccessToast) {
        if (_.isEmpty(result.errors)) {
          this.ToasterService.pop({
            type: ToastType.Info,
            text: this.successMessageFor(result.updatedRemoteAgentName)
          });
        } else {
          this.ToasterService.pop({
            type: ToastType.Error,
            text: this.errorMessageFor(result.errors[0], datasource)
          });
        }
      }
      return result;
    });

  }

  private errorMessageFor(error: IError, datasource: IDataSourceBase) {
    switch (error.code) {
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

  private successMessageFor(updatedRemoteAgentName: string): string {
    // If there is an agent name, the backend found a agent for this reservation right away.
    return _.isEmpty(updatedRemoteAgentName)?
      // Use a generic message that does not include the agent name.
      this.$translate.instant('editRemoteRefreshPropertiesAgentReservationSuccess') :
      // Use that agent name in the success message.
      this.ChangeDatasourceRemoteAgentAction.successMessageFor(updatedRemoteAgentName);
  }

}

Module.instance().service('ChangeDatasourceRemoteAgentReservationAction',
  ChangeDatasourceRemoteAgentReservationAction);
